<template lang="pug">
#view-container
  app-header
  .content-container
    .heading Your bag is...
    
    transition(name='fade' mode='out-in')
      .details-container(:key='index')
        .image-container(
          :style="{'background-image':'url(/_/lv-quiz/img/products/'+bag.img_id+')'}")
          .spacer
          .arrow.left(@click='prev')
            <svg width="33" height="14" viewBox="0 0 33 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M33 7H2M2 7L8 1M2 7L8 13" stroke="#19110B" stroke-width="2"/> </svg>
          .arrow.right(@click='next')
            <svg width="33" height="14" viewBox="0 0 33 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0 7L31 7M31 7L25 13M31 7L25 1" stroke="#19110B" stroke-width="2"/> </svg>
        .text-container
          .code {{bag.sku}}
          .name {{bag.name}}
          .description {{bag.description}}
          .recreate(v-if='bag.recreate') Recreate this bag with the color and hardware of your choice through Now Yours.
    .button-container
      router-link.button(to='/') Take the Quiz Again

</template>

<script>
export default {
  data(){
    return {
      index: 0,
    }
  },
  mounted(){
    if(!this.bag) this.$router.push('/')  
  },
  computed: {
    bags(){
      let bags = this.$store.getters.topProducts
      bags = bags.map(([sku]) => Object.assign({sku}, this.$store.state.quiz.products[sku]))
      bags = bags.filter(product => !!product)
      // Add the filter here for bags removed
      bags = bags.slice(0, 3)
      return bags
    },
    bag(){
      return this.bags[this.index]
    },
  },
  methods: {
    next(){
      return this.index = (this.index + 1) % this.bags.length
    },
    prev(){
      this.index --
      if(this.index < 0) this.index = this.bags.length - 1
    },
  },
}
</script>

<style lang="sass" scoped>
@import @/sass/_all.sass
#view-container
  overflow-x: hidden
  width: 100%
  height: 100%
  display: grid
  grid-template-columns: 1fr
  grid-template-rows: auto 1fr
  .content-container
    justify-items: center
    display: grid
    grid-template-columns: 1fr
    grid-template-rows: auto 1fr auto

    .heading
      font-size: 24px
      line-height: 32px
      font-weight: 500
      padding-top: 40px
      padding-bottom: 24px
      text-align: center
    .button-container
      text-align: center
      padding-bottom: 48px
      padding-top: 24px
    .button
      flex-grow: 0
      flex-shrink: 0
      width: auto
      display: inline-block

    .details-container
      padding: 0 100px
      width: 100%
      max-width: 1200px
      display: grid
      grid-template-columns: 450px auto
      grid-gap: 32px
      align-items: center
      position: static
      
      +range(0, $break-tablet)
        max-width: 400px
        grid-template-columns: auto
        position: relative
        padding: 0

      .image-container
        background-color: #F6F5F3
        background-size: contain
        background-position: center
        background-repeat: no-repeat
        display: flex
        justify-content: center
        align-items: center
        position: static
        .spacer
          padding-bottom: 100%

        .arrow
          cursor: pointer
          $size: 80px
          width: $size
          height: $size
          background: #FFFFFF
          border: 1px solid #E6E4E0
          display: flex
          justify-content: center
          align-items: center
          position: absolute
          z-index: 999999

          &.left
            left: 0

          &.right
            right: 0

        +range(0, $break-tablet)
          position: relative
          .arrow
            $size: 48px
            width: $size
            height: $size
            svg
              height: 11px
              width: auto

      .text-container
        padding-right: 28px
        +range(0, $break-tablet)
          padding: 0 28px
        .code
          font-size: 16px
          line-height: 24px
          font-weight: 500
          padding-bottom: 4px

        .name
          font-size: 32px
          font-weight: 700
          line-height: 40px
          padding-bottom: 16px

        .description, .recreate
          font-size: 18px
          line-height: 28px

        .recreate
          padding-top: 1em
          font-weight: 500

    +range(0, $break-tablet)
      .heading
        padding-top: 24px
        padding-bottom: 20px
        font-style: normal
        font-weight: 600
        font-size: 28px
        line-height: 40px

</style>